import { isLEHotelAccommodationItemView } from 'lib/checkout/checkoutUtils'

function getItemViewAppliedLoyaltyUpgrade(itemView: App.Checkout.AnyItemView): App.Checkout.AccommodationItemViewLoyaltyUpgrade | undefined {
  if (isLEHotelAccommodationItemView(itemView) && itemView.item.hasLoyaltyBenefitRoomUpgrade) {
    return itemView.loyaltyUpgrade
  }
}

export default getItemViewAppliedLoyaltyUpgrade
